<template>
  <div>
    <div class="main">
      <div class="banner">
        <img src="../../assets/product/product_bg.png"/>
      </div>
      <div class="product_intro">
        <div class="intro">
          <div :class="['introList cursor',activeIndex == i ? 'introListActive' :'']" v-for="(v, i) in data"
               :key="i" @click="productTap(i)">
            <span :class="`icon ${v.icon}`"></span>
            <span class="text">{{ v.title }}</span>
          </div>
        </div>

        <div class="product" ref="product">
          <div class="product_box" v-for="(v, i) in data" :key="i">
            <div v-if="i % 2 == 0" class="product_left">
              <img :src="v.img"/>
              <div class="info">
                <span class="title">{{ v.title }}</span>
                <div v-for="(r, i) in v.list" :key="i">
                  <span class="textinfo">{{ r }}</span>
                  <span class="circle"></span>
                </div>
                <p class="englishinfo">{{ v.egDepict }}</p>
              </div>
            </div>
            <div v-else class="product_right">
              <div class="info">
                <span class="title">{{ v.title }}</span>
                <div v-for="(r, i) in v.list" :key="i">
                  <span class="circle"></span>
                  <span class="textinfo">{{ r }}</span>
                </div>
                <p class="englishinfo">{{ v.egDepict }}</p>
              </div>
              <img :src="v.img"/>
            </div>
          </div>
        </div>
        <div class="line"></div>
      </div>
    </div>
  </div>
</template>

<script>
import {Data} from "@/utils/ decorator";

export default {
  name: "product",
  data() {
    return {
      data: [],
      activeIndex: null,
    };
  },

  @Data('product')
  created() {
    this.data = this.d;
  },
  mounted() {
    const index = this.data.findIndex(r => r.id == this.$route.query.id);
    this.productTap(index);
  },
  methods: {
    productTap(i) {
      const offsetTop = this.$refs.product.children[i].offsetTop;
      this.activeIndex = i;
      scrollTo({
        top: offsetTop - 20,
        behavior: 'smooth'
      });
    },
  }
};
</script>

<style lang="less" scoped>


.main {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: auto;

  .banner {
    width: 100%;
    height: 631px;

    img {
      height: 100%;
      width: 100%;
    }
  }

  .product_intro {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .intro {
      display: flex;
      justify-content: center;
      margin-top: -100px;

    }

    .introList:nth-of-type(1) {
      border-radius: 10px 0 0 10px;
    }

    .introList:last-child {
      border-radius: 0 10px 10px 0;
    }

    .introList {
      border-bottom: 1px solid gainsboro;
      width: 150px;
      height: 150px;
      background-color: #ffffff;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .icon {
        color: gainsboro;
      }

      .text {
        width: 89px;
        height: 18px;
        font-size: 13px;
        text-align: center;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        margin-top: 10px;
      }
    }


    .introList:hover {
      transition: .5s;
      background: #ff5b5b;

      .icon,
      .text {
        color: white;
      }
    }

    .introListActive {
      background: #ff5b5b;

      .icon,
      .text {
        color: white;
      }
    }

    .product {
      display: flex;
      flex-direction: column;

      .product_left {
        width: 1108px;
        height: 394px;
        margin-top: 100px;
        display: flex;

        img {
          width: 620px;
          height: 392px;
        }

        .info {
          width: 300px;
          margin-left: 100px;
          text-align: right;

          .title {
            text-align: right;
            width: 300px;
            height: 44px;
            font-size: 30px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
          }

          div:nth-of-type(1) {
            margin-top: 30px;
          }

          div {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            width: 300px;
            height: 30px;
            line-height: 30px;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #666666;

            .circle {
              width: 7px;
              height: 7px;
              background: #ff5b5b;
              border-radius: 50%;
              margin-left: 10px;
            }
          }

          .englishinfo {
            margin-top: 40px;
            width: 300px;
            height: 56px;
            font-size: 32px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #999999;
            line-height: 48px;
            opacity: 0.15;
          }
        }
      }

      .product_right {
        width: 1108px;
        height: 394px;
        margin-top: 100px;
        display: flex;

        img {
          width: 620px;
          height: 392px;
        }

        .info {
          width: 310px;
          margin-left: 50px;
          margin-right: 100px;
          text-align: left;

          .title {
            text-align: left;
            width: 310px;
            height: 44px;
            font-size: 30px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
          }

          div:nth-of-type(1) {
            margin-top: 30px;
          }

          div {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            width: 310px;
            height: 30px;
            line-height: 30px;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #666666;

            .circle {
              width: 7px;
              height: 7px;
              background: #ff5b5b;
              border-radius: 50%;
              margin-right: 10px;
            }
          }

          .englishinfo {
            margin-top: 40px;
            width: 310px;
            height: 56px;
            font-size: 30px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #999999;
            line-height: 48px;
            opacity: 0.15;
          }
        }
      }
    }

    .line {
      margin-bottom: 40px;
      margin-top: 20px;
      width: 1263px;
      height: 1px;
      background: #999999;
      opacity: 0.1;
    }
  }
}
</style>
